import { FlowsheetContent, NodeShapes, UnitTagState } from "@/components/FlowSheetEditor/services/modal"
import { mm2px, px2mm } from "@/utils/size"
import { Cell } from "@antv/x6"
import isNumber from 'lodash/isNumber'
import assign from "lodash/assign";

type ConvertFn = (val: number) => number

function copyObj(obj: Object) {
  return JSON.parse(JSON.stringify(obj))
}

export function contentUnitConvertToMM(content: FlowsheetContent) {
  return convertContentTo(copyObj(content), px2mm)
}


export function contentUnitConvertToPX(content: FlowsheetContent) {
  return convertContentTo(copyObj(content), mm2px)
}

function convertContentTo(content: FlowsheetContent, convert: ConvertFn) {
  const {tempCells = [], sheets} = content

  tempCells.forEach(item => {
    if (item.shape === NodeShapes.Edge) {
      assign(item, changeEdgeUnit(item, convert))
      return;
    } else {
      changeNodeUnit(item, convert)
    }
  })

  sheets.forEach((sheet) => {
    const { nodes, lines, polylines = [], connections = [], jumps = [], overridedNodes = []} = sheet;

    [...lines, ...polylines].forEach(item => {
      assign(item, changeEdgeUnit(item, convert))
      if (item.tagOption) {
        changeTagUnit(item.tagOption, convert)
      }
    });
    [...nodes, ...connections, ...jumps, ...overridedNodes].forEach((item: any) => {
      changeNodeUnit(item, convert)
      if (item.tagOption) {
        changeTagUnit(item.tagOption, convert)
      }
    });
  })
  
  return {
    ...content,
    tempCells,
    sheets
  }
}

function changeTagUnit(tagOption: UnitTagState, convert: ConvertFn) {
  const {size, offset} = tagOption
  size.width = convert(size.width);
  size.height = convert(size.height);
  offset.x = convert(offset.x);
  offset.y = convert(offset.y);
}

function changeEdgeUnit(line: Cell.Properties, unitConvert: ConvertFn) {
  const {vertices = [], source, target} = line;

  const points = vertices.map((item) => {
    return {
      x: unitConvert(item.x),
      y: unitConvert(item.y)
    }
  })

  let newSource = {...source}
  let newTarget = {...target}
  if (isNumber(newSource.x) && isNumber(newSource.y)) {
    newSource = {
      x: unitConvert(newSource.x),
      y: unitConvert(newSource.y)
    }
  }
  if (isNumber(newTarget.x) && isNumber(newTarget.y)) {
    newTarget = {
      x: unitConvert(newTarget.x),
      y: unitConvert(newTarget.y)
    }
  }

  return {
    ...line,
    vertices: points,
    source: newSource,
    target: newTarget
  }
}

function changeNodeUnit(item: Cell.Properties, unitConvert: ConvertFn) {
  const {position, size} = item;
  position.x = unitConvert(position.x)
  position.y = unitConvert(position.y)
  size.width = unitConvert(size.width)
  size.height = unitConvert(size.height)
}